// extracted by mini-css-extract-plugin
module.exports = {"m1sgx1iy":"m1sgx1iy","c1kd1wia":"c1kd1wia"};